import React, {useEffect} from "react";
import { useForm } from "react-hook-form";
import { IoCloseOutline } from "react-icons/io5";
import "./JobDetails.scss";
import masterApi from "../../services/masterApi";
import { useState } from "react";

export default function CreateBoard({ closePopup,reloadData,boardId, boardList, isEditMode=false}) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({});
  const [boardPosition, setBoardPosition] = useState(1);

  useEffect(() => {
    if(!isEditMode){
      let maxPosition = 0;
      for(let board of boardList){
        if(board.boardPosition > maxPosition){
          maxPosition = board.boardPosition;
        }
      }
      setBoardPosition(maxPosition + 1);
    }
  }, [boardList]);

  useEffect(() => {
    const fetchDetails = async () => {
        // debugger;
        let response = await masterApi.getBoardById(boardId);          
        if (response?.data?.ok) {
          setValue("boardName", response?.data?.board?.boardName);
          setValue("boardPosition", response?.data?.board?.boardPosition);
        }               
    };
    fetchDetails();        
}, [boardId]);
  const onSubmit = async (data) => {
    // debugger;
    if(boardId){
      data.id=boardId;
      const response = await masterApi.editBoard(data);    
    if(response?.ok){
      closePopup();
      reloadData();
    }else{
      alert(response?.response?.data?.message);
    }
    }
    else{
    const response = await masterApi.createBoard(data);    
    if(response?.data?.ok){
      closePopup();
      reloadData();
    }else{
      alert(response?.response?.data?.message);
    }
  }
  };
  return (
    <div className="popup-container center-popup">
      <div className="shadeClose" onClick={closePopup}></div>
      <div className="popup-inner">
        <div className="inner-design">
          <div className="popup-header d-flex align-items-center gap-2">
            <h2>
              Create Board {/*for <span>#HR00002</span>*/}
            </h2>
            <button type="button" className="ms-auto close-btn" onClick={closePopup}>
              <IoCloseOutline />
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="popup-content">
              <div className="row">
                {/* Board Name */}
                <div className="col-12 col-md-12 mb-4 position-relative">
                  <label className="form-label">
                    Board Name <span className="asterisk danger">*</span>
                  </label>
                  <input type="text" className="form-control" {...register("boardName", { required: "Board Name is required" })} />
                  {errors.boardName && <div className="invalid-feedback position-absolute mt-0 position-absolute pe-4 mt-0 position-absolute pe-4 mt-0">{errors.boardName.message}</div>}
                </div>

                {/* Position */}
                <div className="col-12 col-md-6 mb-0 position-relative">
                  <label className="form-label">
                    Position <span className="asterisk danger">*</span>
                  </label>
                  <select className="form-select" {...register("boardPosition", { required: "Board Position is required" })}>
                    <option value="">Select</option>
                    {Array.from({ length: 20 }, (_, i) => (
                      <option key={i + boardPosition} value={i + boardPosition}>
                        {i + boardPosition}
                      </option>
                    ))}
                  </select>
                  {errors.boardPosition && <div className="invalid-feedback position-absolute mt-0 position-absolute pe-4 mt-0 position-absolute pe-4 mt-0">{errors.boardPosition.message}</div>}
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="popup-footer position-absolute w-100 d-flex">
              <div className="ms-auto d-flex gap-2">
                <button type="button" className="btn btn-dark" onClick={closePopup}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success">
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
